// extracted by mini-css-extract-plugin
module.exports = {"selectImageError":"newMap_selectImageError__3YWi8"};